import React, { useEffect, useState } from "react";
import { Toggle } from "components/Toggle";
import { Select } from "components/Select";
import { MAIN_OPTIONS, TOGGLE_OPTIONS } from "constants/dashboard";
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { initPatientRegionsPage } from "store/PatientRegionsStore/actions";
import { selectCurrentClinician } from "store/ClinicianStore/selectors";
import { UserListContaier } from "./containers/UserListContaier";
import { USER_GROUPS } from "constants/roles";
import { Grid, Chip } from "@mui/material";
import { inputStyle, tagIconstyle, tagStyle } from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import { filterSportCategories } from "store/PatientStore/actions";
import { initClinicianPage } from "store/ClinicianStore/actions";
import { SearchBox } from "components/SearchBox/SearchBox";
import { icons } from "constants/icons";
import { FilterModal } from "components/FilterModal/FilterModal";
import { FilterType } from "constants/types";
import { updateClinician } from "store/ClinicianStore/actions";

export const PatientOverview = () => {
  const dispatch = useAppDispatch();
  const [selectedTab, setSelectedTab] = useState(0);

  const currentClinician: any = useAppSelector(selectCurrentClinician);
  const [tags, setTags] = useState<string[]>([]);
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const [openFilterModal, setOpenFilterModal] = useState<boolean>(false);

  const addToTags = (value: string) => {
    setTags([...tags, value]);
  };

  const removeFromTags = (value: string) => {
    setTags(tags.filter((item) => item !== value));
  };

  const removeFromSelectedTags = (value: string) => {
    setSelectedTags(selectedTags.filter((item) => item !== value));
  };

  const resetFilter = () => {
    setTags([]);
    setSelectedTags([]);
  };
  const onItemSelected = (e: any, name: string) => {
    if (e.target.checked) {
      addToTags(name);
    } else {
      removeFromTags(name);
    }
  };

  useEffect(() => {
    if (!currentClinician?.role?.includes(USER_GROUPS.SUPER_ADMIN)) {
      dispatch(initPatientRegionsPage());
      dispatch(initClinicianPage());
    }

    if (currentClinician?.role?.includes(USER_GROUPS.COACH)) {
      const hasInvitedStatus =
        currentClinician?.profileInfo?.authStatus === "invited";
      if (hasInvitedStatus) {
        dispatch(
          updateClinician(currentClinician?._id, {
            authStatus: "registered",
          })
        );
      }
    }
  }, [currentClinician]);

  useEffect(() => {
    dispatch(filterSportCategories(selectedTags));
  }, [selectedTags]);

  return (
    <div className="container max-w-[90%] m-auto pt-[40px]">
      <h1 className="leading-10">
        {currentClinician?.role?.includes(USER_GROUPS.COACH) && (
          <>
            Hi, {currentClinician?.profileInfo.firstName}{" "}
            {currentClinician?.profileInfo.lastName}.{"\n"} Here is your athlete
            overview.
          </>
        )}
        {currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) && (
          <>
            Hi, Dr. {currentClinician?.profileInfo.lastName}.{"\n"} Here is your
            patient overview.
          </>
        )}
      </h1>

      {currentClinician?.role?.includes(USER_GROUPS.CLINICIAN) && (
        <section className="w-full mt-8">
          <div className="flex items-center space-x-2">
            <div className="w-32">
              <Select
                options={MAIN_OPTIONS}
                onChange={() => {}}
                selectedOption={MAIN_OPTIONS[0]}
              />
            </div>
          </div>
        </section>
      )}

      {
        <section className="w-full mt-8">
          <div className="flex flex-wrap space-x-6 pl-2.5">
            {currentClinician?.role?.includes(USER_GROUPS.COACH) ? (
              <Grid item md={12} xl={12} container>
                <Grid
                  md={2}
                  xl={2}
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <h2 style={{ marginRight: 12 }}>Athlete List</h2>
                  {selectedTab === 0 && (
                    <img
                      aria-hidden="true"
                      src={icons.filterDetail}
                      alt="filterDetail"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setOpenFilterModal(true);
                      }}
                    />
                  )}
                </Grid>
                <Grid
                  md={7}
                  xl={7}
                  container
                  justifyContent="flex-start"
                  sx={{ pl: "3%" }}
                >
                  {selectedTags &&
                    selectedTags.length > 0 &&
                    selectedTags.map((tag) => (
                      <Grid item justifyContent="space-between">
                        <Chip
                          key={tag}
                          style={tagStyle}
                          deleteIcon={<CloseIcon style={tagIconstyle} />}
                          label={tag}
                          variant="outlined"
                          onDelete={() => {
                            removeFromSelectedTags(tag);
                            removeFromTags(tag);
                          }}
                        />
                      </Grid>
                    ))}
                </Grid>
                <Grid
                  md={3}
                  xl={3}
                  paddingLeft={0}
                  container
                  justifyContent="flex-end"
                >
                  {selectedTab === 0 && <SearchBox isAthlete={true} />}
                </Grid>
                {selectedTab === 0 && (
                  <FilterModal
                    fromSection="ATHLETE_LIST"
                    isEnabled={openFilterModal}
                    setIsEnabled={setOpenFilterModal}
                    operation={FilterType.ATHLETE_FILTER}
                    currentClinician={currentClinician}
                    tags={tags}
                    applyFilter={close}
                    inputStyle={inputStyle}
                    onItemSelected={onItemSelected}
                    resetFilter={resetFilter}
                  />
                )}
              </Grid>
            ) : (
              <>
                <h2>Patient List</h2>
                <Toggle
                  optionLeft={TOGGLE_OPTIONS.optionLeft}
                  optionRight={TOGGLE_OPTIONS.optionRight}
                  selectedOption={TOGGLE_OPTIONS.optionRight}
                  onClick={() => {}}
                />
              </>
            )}
          </div>
          <UserListContaier
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        </section>
      }
    </div>
  );
};
